<template lang="pug">
.time-entries-wrapper
  .margin-top.text-center
    img(
      :src="noActivityImageUrl"
      alt="locations no activity"
      width="420"
      height="360"
    )
    h4.margin-top
      | There isn't any time tracked yet for this time period and member. To track time, use one of our apps.
  .margin-top.text-center
    a.btn.btn-primary.btn-lg(
      href="/download"
      rel="noopener noreferrer"
      target="_blank"
    ) Download app
</template>
<script>
import { IMAGE_NO_ACTIVITY } from '~/rails_assets';

export default {
  name: 'TimeEntriesNoData',
  data() {
    return {
      noActivityImageUrl: IMAGE_NO_ACTIVITY,
    };
  },
};
</script>
